export default "__VITE_ASSET__BzhWK16$__"